import React from "react";

export default function FacebookIcon({
  size = 30,
  width,
  height,
  ...rest
}: {
  size?: number;
  width?: number;
  height?: number;
  [key: string]: any;
}) {
  return (
    <svg
      {...rest}
      width={width || size}
      height={height || width}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_10628_86100"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H29.9999V29.9998H0V0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_10628_86100)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.185 11.0513L16.1837 11.0526C16.1975 10.5601 16.5812 10.1588 17.0725 10.125H18.5537V7.50005H15.3662C13.0825 7.91505 13.4212 10.6575 13.4212 10.6575V12.2363H11.4475V15H13.4212V22.5H16.1837V15H18.2187L18.56 12.2351H16.185V11.0513ZM15 0C23.2838 0 30 6.71625 30 15C30 23.2838 23.2838 30 15 30C6.71625 30 0 23.2838 0 15C0 6.71625 6.71625 0 15 0Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
